module.exports = __webpack_public_path__ + "static/media/adrenalin.575c313d.png";